import type { ErrorInfo, ReactNode } from 'react';
import React, { Component } from 'react';
import { isBrowser } from '@noths/polaris-client-utils';

import * as styles from './ErrorBoundary.styles';

interface ErrorBoundaryState {
  error: Error | null;
  errorInfo: ErrorInfo | null;
}

export interface ErrorBoundaryProps {
  children: ReactNode | undefined;
  env: string;
  isLoggingEnabled: boolean;
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    const { isLoggingEnabled } = this.props;

    if (isLoggingEnabled && isBrowser()) {
      console.log(error);
      console.log(errorInfo);
    }
    this.setState({
      error,
      errorInfo,
    });
  }

  render() {
    const { errorInfo } = this.state;
    const { children } = this.props;

    if (errorInfo) {
      return (
        <div css={styles.errorBoundary}>
          <h1 css={styles.heading}>Something went wrong.</h1>
        </div>
      );
    }

    return children;
  }
}
